

import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API } from "../backend";
import authHeader from "../services/auth-header";
import axios from "axios";
import AuthService from "../services/auth.service";
import { getTrans as t } from "../Localization/translations";
import GetCompanyInfoService from "../services/company/getCompanyInfoService";
import { IMAGE } from "../backend";
import { useProSidebar } from "react-pro-sidebar";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import Model from "../Supportticket/model";
import NotesAll from "./Notes/NotesAll";
import NotesSingle from "./Notes/NotesSingle";
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import Badge from "@material-ui/core/Badge";





function Navigation({
  setMenuShowHide,
  menuShowHide,
  customerPermission,
  profileImage,
  customData,
  notesLength,
  setRtl
}) {
  const [query, setQuery] = useState("");
  const [image, setImage] = useState("");
  const [showhide, setShowHide] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [state, setState] = useState('');
  const [contract_type, setContract_type] = useState("");
  // const [notesFromDropdown, setNotesFromDropdown] = useState(false); // OLD LOGIC COMMENTED
  const [notesPanelType, setNotesPanelType] = useState(""); // 'all', 'single', ''
  const path = useLocation();

  const [pendingApprovals, setPendingApprovals] = useState(0);

  let parent = localStorage.getItem("parent");
  let navigate = useNavigate();
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const [permissionsArray, setPermissionsArray] = useState(
    permissionss ? permissionss.split(",") : []
  );
  const location = useLocation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);


  useEffect(() => {
    const pathh = location.pathname;
    if (pathh === "/user") {
      const value = localStorage.getItem("permissions");
      setPermission(localStorage.getItem("permissions"));
      setPermissionsArray(value ? value.split(",") : []);
    }
  }, [location]);

  const handelDefault = () => {
    if (customerPermission !== "Customer") {
      GetCompanyInfoService.getCompanyInfo().then((response) => {
        localStorage.setItem("companyName", response.data.company_name);
        setImage(response.data.image);
      })
    } else if (customerPermission === "Customer") {
      GetCompanyInfoService.getCompanyProfileImage().then((response) => {
        setImage(response.data.image);
      })
    }
  };

  useEffect(() => {
    setShowHide(parent);
    Autologout();

    handelDefault();
  }, []);

  useEffect(() => {
    if (profileImage === true) {
      handelDefault();
    }
  }, [profileImage, image]);

  const handleSearch = () => {
    if (query !== "") {
      navigate("/globalsearch", { state: query });
      setQuery("");
    } else {
      return false;
    }
  };

  const logOut = () => {
    AuthService.logout()
      .then(() => {
        // navigate("/");
        window.location.href = "/";

      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  const Autologout = () => { };

  const handleContractNavigation = (path, { state }) => {
    navigate(path, { state });
  };

  const handleShow = () => {
    setMenuShowHide(true);
    navigate("/settings");
    setRtl(false)
  };
  const { toggleSidebar } = useProSidebar();

  const handleClick = () => {
    setShowTooltip(!showTooltip);
    setModalVisible(true);
  };

  // NEW BLUE TICKET HANDLER - SEPARATE LOGIC
  const handleNewTicketClick = () => {
    // Navigate based on user type for new ticket system
    if (customerPermission === 'Customer') {
      navigate('/customerticket');
    } else {
      navigate('/companyticket');
    }
  };

  const handlecontractLoan = ({ state }) => {
    navigate("/create-loan", { state });
  };

  const handlecontractLease = ({ state }) => {
    navigate("/create-lease", { state });
  };

  const handlecontractRent = ({ state }) => {
    navigate("/create-rental", { state });
  };

  // useEffect(() => {
  //   GetCompanyInfoService.getCompanySettingInfo().then(
  //     (response) => {
  //       setContract_type(response.data.contract_type)
  //     }
  //   )
  // }, [])

  // Helper to determine if current path needs NotesSingle panel
  const isSingleNotesPage = () => (
    path.pathname === '/party/details' ||
    path.pathname === '/editparty' ||
    path.pathname === '/editloancontract' ||
    path.pathname === '/contract/view' ||
    path.pathname === '/contract/edit' ||
    path.pathname === '/editrentalcontract' ||
    path.pathname === '/receipts/viewreceipts' ||
    path.pathname === '/receipts/editreceipts' ||
    path.pathname === '/billing/viewinvoices' ||
    path.pathname === '/billing/editinvoices'
  );

  // Dropdown notes click: sets correct notes panel type for any page
  // OLD LOGIC COMMENTED BELOW:
  /*
  const handleNotesDropdownClickOld = () => {
    setIsSidePanelOpen(true);
    if (path.pathname === '/') {
      setNotesFromDropdown(true);
      setSelectedValue && setSelectedValue('');
      setOptions2 && setOptions2([]);
      setState && setState('');
    }
  };
  */
  // NEW LOGIC FOR ALL PAGES:
  const handleNotesDropdownClick = () => {
    setIsSidePanelOpen(true);
    // Home page = all, selected detail pages = single, fallback to all
    if (path.pathname === '/') {
      setNotesPanelType('all');
      setSelectedValue && setSelectedValue('');
      setOptions2 && setOptions2([]);
      setState && setState('');
    } else if (isSingleNotesPage()) {
      setNotesPanelType('single');
    } else {
      setNotesPanelType('all'); // fallback for other pages: open all notes
      setSelectedValue && setSelectedValue('');
      setOptions2 && setOptions2([]);
      setState && setState('');
    }
  };

  const loadPendingApprovals = async () => {
    try {
      const res = await axios.get(API + "approvals/tasks/", {
        headers: authHeader(),
      });

      const data = res.data || [];
      setPendingApprovals(data.length);
    } catch (err) {
      console.error("Approval count error", err);
    }
  };

  useEffect(() => {
    loadPendingApprovals();
  }, [location.pathname]);

  return (
    <>
      <nav
        className="navbar navbar-main navbar-expand-lg "
        id="navbarBlur"
        navbar-scroll="true"
      >
        <div className="container-fluid px-3 px-sm-3">
          <div
            className="s d-flex navbar-collapse mt-sm-0 ml-sm-5 me-md-0 me-sm-4"
            id="navbar"
          >
            <span
              className="nav-link text-body p-0"
              id="configureMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i
                className="fa fa-thin fa-bars d-lg-none fixed-plugin-button-nav cursor-pointer"
                onClick={() => toggleSidebar()}
              ></i>
            </span>
            <i
              className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute right-0 top-0 d-none d-xl-none"
              aria-hidden="true"
              id="iconSidenav"
            ></i>
            <Link className="navbar-brand m-0" to="/">
              {image !== null ? (
                <img src={image} alt="Logo" className="im logo-mobile" />
              ) : (
                <img
                  src={process.env.PUBLIC_URL + "/static/images/logo.png"}
                  alt="Athena Fintech"
                  className="logo im logo-mobile"
                />
              )}
            </Link>
            <div className="ms-md-auto ps-md-3 d-flex flex-column flex-md-row align-items-end">
              <div className="bg-white border-radius-lg d-flex align-items-center w-100 w-md-auto">
                <input
                  onChange={(e) => setQuery(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  value={query}
                  name="q"
                  type="text"
                  className="form-control"
                  style={{ marginRight: '0.25rem', marginBottom: '0.25rem' }}
                  placeholder={t("Type here...")}
                />
              </div>
              <ul className="navbar-nav mb-2 mb-sm-0 ms-sm-auto justify-content-sm-end">
                <li className="nav-item d-flex  align-items-center">
                  {/* {customerPermission !== "Customer" ? ( */}




                  <li className="nav-item dropdown d-sm-block pe-2 px-4 d-flex align-items-center">

                    <span
                      className="nav-link text-body p-0"
                      onClick={() => navigate("/approvals")}
                      style={{ cursor: "pointer" }}
                    >
                      <Badge
                        badgeContent={pendingApprovals}
                        color="secondary"
                        overlap="circular"
                        invisible={pendingApprovals === 0}
                      >
                        <VerifiedUserIcon style={{ color: "#245C7F", fontSize: 26 }} />
                      </Badge>
                    </span>

                    {/* <ul
                      className="dropdown-menu px-2 py-3 ms-sm-n4"
                      aria-labelledby="configureMenuButton"
                    >
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_party") === true ? (
                          <Link
                            className="dropdown-item border-radius-md"
                            to="/addnewparty"
                          >
                            {t("New Party")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_contract") === true ? (
                          <span className="dropdown-item border-radius-md">
                            {t("New Contract")} &raquo;{" "}
                          </span>
                        ) : (
                          ""
                        )}
                        <ul className="dropdown-item dropdown-submenu">
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractLease({ state: "Lease" })
                            }
                          >
                            {t("Lease")}
                          </span>
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractLoan({ state: "Loan" })
                            }
                          >
                            {t("Loan")}
                          </span>
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              handlecontractRent({ state: "Rental" })
                            }
                          >
                            {t("Rental")}
                          </span>
                        </ul>
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_invoiceheader") ===
                          true ? (
                          <Link
                            className="dropdown-item"
                            to="/billing/createinvoices"
                          >
                            {t("New Invoice")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      <li className="mb-2">
                        {permissionss &&
                          permissionsArray.includes("add_receipts") === true ? (
                          <Link
                            className="dropdown-item"
                            to="/receipts/createreceipts"
                          >
                            {t("New Receipt")}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      {/* 
                          OLD NOTES BUTTON LOGIC (COMMENTED)
                        <li className="mb-2">
                          <span
                            className="dropdown-item"
                            onClick={() => {
                              setIsSidePanelOpen(true);
                              setNotesFromDropdown(path.pathname === '/');
                              setSelectedValue && setSelectedValue('');
                              setOptions2 && setOptions2([]);
                              setState && setState('');
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                              }
                              alt="notes"
                              height='25px'
                              width='25px'
                              style={{ marginRight: "8px", verticalAlign: "middle" }}
                            />
                            {t("Notes")}
                          </span>
                        </li>
                        */}
                    {/* 
                          NEW NOTES BUTTON LOGIC FOR ALL PAGES 
                        */}
                    {/*                         
                      <li className="mb-2">
                        <span
                          className="dropdown-item"
                          onClick={handleNotesDropdownClick}
                        >
                          {/* <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/assets/img/curved-images/icons8-sticky-notes-96.png"
                              }
                              alt="notes"
                              height='25px'
                              width='25px'
                              style={{ marginRight: "8px", verticalAlign: "middle" }}
                            /> */}
                    {/* {t("New Note")} */}
                    {/* </span> */}
                    {/* </li> */}

                    {/* </ul>  */}
                  </li>





                  {/* ) : (
                    ""
                  )} */}
                  {/* 
                    OLD NOTES PANEL RENDERING LOGIC (COMMENTED)
                  {customerPermission !== "Customer" && isSidePanelOpen && (
                    // Home page: open NotesAll only if triggered from dropdown
                    path.pathname === '/' && notesFromDropdown ? (
                      <NotesAll
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        setSelectedValue={setSelectedValue}
                        setOptions2={setOptions2}
                        setState={setState}
                        isSidePanelOpen={isSidePanelOpen}
                        options2={options2}
                        selectedValue={selectedValue}
                        state={state}
                      />
                    ) : (
                      // Other pages: common logic as before
                      path.pathname === '/party/details' ||
                      path.pathname === '/editparty' ||
                      path.pathname === '/editloancontract' ||
                      path.pathname === '/contract/view' ||
                      path.pathname === '/contract/edit' ||
                      path.pathname === '/editrentalcontract' ||
                      path.pathname === '/receipts/viewreceipts' ||
                      path.pathname === '/receipts/editreceipts' ||
                      path.pathname === '/billing/viewinvoices' ||
                      path.pathname === '/billing/editinvoices' ?
                        <NotesSingle
                          setIsSidePanelOpen={setIsSidePanelOpen}
                          isSidePanelOpen={isSidePanelOpen}
                          state={customData.object_id}
                          object_name={customData.object_name}
                        /> : ''
                    )
                  )}
                  */}
                  {/* 
                    NEW NOTES PANEL RENDERING LOGIC FOR ALL PAGES 
                  */}
                  {customerPermission !== "Customer" && isSidePanelOpen && (
                    notesPanelType === 'all' ? (
                      <NotesAll
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        setSelectedValue={setSelectedValue}
                        setOptions2={setOptions2}
                        setState={setState}
                        isSidePanelOpen={isSidePanelOpen}
                        options2={options2}
                        selectedValue={selectedValue}
                        state={state}
                      />
                    ) : notesPanelType === 'single' ? (
                      <NotesSingle
                        setIsSidePanelOpen={setIsSidePanelOpen}
                        isSidePanelOpen={isSidePanelOpen}
                        state={customData.object_id}
                        object_name={customData.object_name}
                      />
                    ) : null
                  )}
                  {/* END NOTES PANEL RENDERING LOGIC */}

                  {customerPermission !== "Customer" && (
                    <div className="cursor-pointer" onClick={handleShow}>
                      <Tooltip position="bottom" title="Settings">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/static/images/ic-settings.svg"
                          }
                          alt="setting"
                        ></img>
                      </Tooltip>
                    </div>
                  )}
                  {/* NEW BLUE TICKET BUTTON - ALWAYS VISIBLE */}
                  {customerPermission === "Customer" ? (
                    // 👉 Show this ONLY for Customer
                    <div
                      className="cursor-pointer"
                      onClick={handleNewTicketClick}
                      style={{ marginRight: "6px" }}
                    >
                      <Tooltip position="bottom" title="Support Portal">
                        <ConfirmationNumberIcon
                          style={{ color: "#a3a7ad", marginLeft: "6px" }}
                        />
                      </Tooltip>
                    </div>
                  ) : (
                    // 👉 Show this when NOT Customer
                    <li className="nav-item dropdown d-sm-block pe-2 px-2 d-flex align-items-center">
                      <span
                        className="nav-link text-body p-0"
                        id="supportMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ cursor: "pointer" }}
                      >
                        <Tooltip position="bottom" title="Support">
                          <ConfirmationNumberIcon
                            style={{ color: "#a3a7ad", marginLeft: "6px" }}
                          />
                        </Tooltip>
                      </span>

                      <ul
                        className="dropdown-menu px-2 py-3 ms-sm-n4"
                        aria-labelledby="supportMenuButton"
                      >
                        <li className="mb-2">
                          <span
                            className="dropdown-item border-radius-md"
                            onClick={handleNewTicketClick}
                          >
                            Support Portal
                          </span>
                        </li>

                        <li className="mb-2">
                          <Link className="dropdown-item border-radius-md" to="/user-guide">
                            User Guide
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link className="dropdown-item border-radius-md" to="/api-guide">
                            Integration Guide
                          </Link>
                        </li>
                      </ul>
                    </li>
                  )}



                  {/* EXISTING SUPPORT TICKET BUTTON */}
                  {/* {customerPermission !== 'Customer' &&
                    <><div
                      className="cursor-pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={handleClick}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      <Tooltip position="bottom" title="Support Ticket"
                      >
                        <ConfirmationNumberIcon
                          style={{ color: "#a3a7ad", marginLeft: "6px" }} />
                      </Tooltip>
                    </div><Model
                        setModalVisible={setModalVisible}
                        modalVisible={modalVisible} /></>
                  } */}
                  <div className="ms-2">
                    {showhide === "0" ? (
                      ""
                    ) : (
                      <Link to="/user" style={{ color: "#67748e" }}>
                        <Tooltip position="bottom" title="Users">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-user.svg"
                            }
                            alt="User"
                          ></img>
                        </Tooltip>
                      </Link>
                    )}
                  </div>
                  <div className="ms-2">
                    <Link
                      onClick={logOut}
                      to="/login"
                      style={{ color: "#67748e" }}
                    >
                      <Tooltip position="bottom" title="Logout">
                        <i className="fa fa-solid  fa-power-off"></i>
                      </Tooltip>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav >
    </>
  );
}

export default Navigation;